<div [ngClass]="'flex max-w-[320px] justify-self-end gap-2' + (disabled() ? ' opacity-50' : '')">
  <div class="flex flex-col justify-center">
    @if (title()) {
      <div class="flex items-center gap-1 text-surface-800 text-[13px] font-semibold font-['Inter'] leading-4">
        {{title()}}
        @if (titleIcon()) {
          <i [class]="titleIcon()"></i>
        }
      </div>
    }
    @if (subtitle()) {
      <div class="text-surface-800 text-xs font-normal font-['Inter'] leading-4">{{subtitle()}}</div>
    }
  </div>
  <div>
    <div [class]="chipClass() + ' rounded-full px-2 py-1 min-w-[92px] text-[13px] flex items-center justify-between'">
      <div class="flex gap-0">
        @if (signed() && value() > 0) {
          <i class="fa-regular fa-plus mx-[-4px]"></i>
        } @else if (signed() && value() < 0) {
          <i class="fa-regular fa-minus mx-[-4px]"></i>
        }
        <i class="fa-regular fa-dollar-sign"></i>
      </div>
      <div>
        {{displayValue() | currency:'AUD':''}}
      </div>
    </div>
  </div>
</div>
